<template>
  <div id="digital-flop">
    <div class="catdsBox">
      <dv-border-box-10>
        <div class="boxBorder">
          <div
            class="digital-flop-item"
            v-for="item in dataSummary"
            :key="item.id"
            @click="handleItemClick(item)"
          >
            <div class="titleHeader">
              <i class="iconfont" :class="`${item.iconfont}`"></i>
              <div class="digital-flop-title">{{ item.title }}</div>
            </div>

            <div class="digital-flop">
              <dv-digital-flop
                :config="item.number"
                :style="{ width: '120px', height: '50px' }"
              />
              <div class="unit">{{ item.unit }}</div>
            </div>
          </div>
          <dv-decoration-10 />
          <dv-decoration-10 class="decorationBox" />
        </div>
      </dv-border-box-10>
    </div>

    <!-- 智能设备弹框 -->
    <div class="dialog-overlay" v-if="dialogVisible" @click="handleClose">
      <div class="dialog-content" @click.stop>
        <div class="dialog-header">
          <h3>智能设备详情</h3>
          <span class="close-btn" @click="handleClose">&times;</span>
        </div>
        <div class="dialog-body">
          <div>
            <div class="decorationBox">
              <div class="title">智能设备</div>
              <dv-decoration-5
                class="decoration5"
                style="width: 160px; height: 30px"
              />
            </div>
            <table class="device-table">
              <thead>
                <tr>
                  <th>设备种类</th>
                  <th>已连接</th>
                  <th>在线</th>
                  <th>离线</th>
                  <th>故障</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in deviceList" :key="index">
                  <td>{{ item.type }}</td>
                  <td>{{ item.connected }}</td>
                  <td>{{ item.online }}</td>
                  <td>{{ item.offline }}</td>
                  <td>{{ item.error }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <dv-border-box-11 :titleWidth="145" title="智能设备" class="catdsBox">
            <div class="right">
              <div class="top">
                <div class="status-container">
                  <h3>装药一体机：【{{ deviceStatus }}】</h3>
                  <img
                    :src="
                      deviceStatus === '待机'
                        ? require('@/assets/img/wait.jpg')
                        : deviceStatus === '运行'
                        ? require('@/assets/img/run.jpg')
                        : require('@/assets/img/other.jpg')
                    "
                    style="width: 30px; height: 30px; margin-left: 10px"
                  />
                </div>
                <span>剩余：{{ countdown }}秒刷新</span>
              </div>
              <div class="middle">
                <h4>亮珠生产实时监控：</h4>
                <div class="activeChart">
                  <dv-charts class="ring-charts" :option="ring2" />
                  <dv-charts class="ring-charts" :option="ring" />
                  <div class="wenshidu">
                    <div
                      :class="`${
                        sparkData.temp[sparkData.temp.length - 1] > 75
                          ? 'wenduRing'
                          : ''
                      }`"
                    >
                      <i class="iconfont icon-wenshidu-"></i>
                      {{ sparkData.temp[sparkData.temp.length - 1] }}°C
                    </div>
                  </div>
                  <i class="iconfont icon-shidu"></i>
                </div>
                <div style="margin-top: 30px">
                  <h4>固引生产实时监控：</h4>
                  <div class="activeChart">
                    <dv-charts class="ring-charts" :option="fixedUnitRing2" />
                    <dv-charts class="ring-charts" :option="fixedUnitRing" />
                    <div class="wenshidu">
                      <div
                        :class="`${
                          fixedUnitData.temp[fixedUnitData.temp.length - 1] > 75
                            ? 'wenduRing'
                            : ''
                        }`"
                      >
                        <i class="iconfont icon-wenshidu-"></i>
                        {{
                          fixedUnitData.temp[fixedUnitData.temp.length - 1]
                        }}°C
                      </div>
                    </div>
                    <i class="iconfont icon-shidu"></i>
                  </div>
                </div>
              </div>
              <div class="bottom">
                <div class="output-box">
                  <div class="box-title">
                    <i class="iconfont icon-wancheng"></i>
                    <span>累计产量：</span>
                  </div>
                  <div class="box-content">
                    <span
                      class="value"
                      :style="{
                        color: totalOutput === '获取异常' ? '#ff4d4d' : ''
                      }"
                      >{{ totalOutput }}</span
                    >
                  </div>
                </div>
                <div class="alarm-box">
                  <div
                    class="box-title"
                    style="display: inline-block; vertical-align: middle"
                  >
                    <i class="iconfont icon-jinggao"></i>
                    <span>有故障：</span>
                  </div>
                  <div
                    class="box-content"
                    style="display: inline-block; vertical-align: middle"
                  >
                    <img
                      :src="fotalOutput ? '/alarm.gif' : '/grey.jpg'"
                      alt="status"
                      style="width: 40px; height: 40px"
                    />
                  </div>
                </div>
                <div>
                  <button class="test-button" @click="handleTest">测试</button>
                </div>
              </div>
            </div>
          </dv-border-box-11>
        </div>
      </div>
    </div>

    <!-- 监控视频弹框 -->
    <div
      class="dialog-overlay"
      v-if="videoDialogVisible"
      @click="handleVideoClose"
    >
      <div class="dialog-content" @click.stop>
        <div class="dialog-header">
          <h3>监控视频详情</h3>
          <span class="close-btn" @click="handleVideoClose">&times;</span>
        </div>
        <div class="dialog-body video-body">
          <iframe
            src="https://223.82.210.176:36100"
            frameborder="0"
            class="video-frame"
            sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-top-navigation allow-top-navigation-by-user-activation"
            referrerpolicy="no-referrer"
            loading="lazy"
          ></iframe>
        </div>
      </div>
    </div>

    <audio
      ref="alarmAudio"
      src="/alarm.MP3"
      preload="auto"
      loop
      @error="handleAudioError"
    ></audio>

    <dv-decoration-10 />
    <dv-decoration-10 class="decorationBox" />

    <!-- 增强的弹窗 -->
    <div
      v-if="showDialog"
      class="modal-overlay"
      @click.self="showDialog = false"
    >
      <div class="modal-contentpro" :class="{ 'modal-enter': showDialog }">
        <!-- 加载动画 -->
        <div v-if="isLoading" class="loading-container">
          <div class="loading-spinner">
            <div class="spinner-ring"></div>
            <div class="spinner-ring"></div>
            <div class="spinner-ring"></div>
          </div>
          <div class="loading-text">数据加载中...</div>
        </div>

        <!-- 主要内容 -->
        <div v-else class="modal-main-content">
          <div class="modal-header">
            <div class="header-title">
              <i class="iconfont icon-xiaoshou"></i>
              <h3>销售服务</h3>
            </div>
            <span class="close-btn" @click="showDialog = false">×</span>
          </div>

          <div class="modal-content">
            <!-- 标签页导航 -->
            <div class="tab-navigation">
              <div
                class="tab-item"
                :class="{ active: activeTab !== 'ranking' }"
                @click="activeTab = 'ranking'"
              >
                <i class="iconfont icon-kehu"></i>
                销量排行
              </div>
              <div
                class="tab-item"
                :class="{ active: activeTab !== 'customer' }"
                @click="activeTab = 'customer'"
              >
                <i class="iconfont icon-paihang"></i>
                客户标签
              </div>
            </div>

            <!-- 标签页内容 -->
            <div class="tab-content">
              <!-- 客户标签页 -->
              <div
                v-if="activeTab === 'customer'"
                class="customer-tags-content"
              >
                <iframe
                  src="https://xfhp.5any.cn/view/home/homeMin.html"
                  frameborder="0"
                  sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
                  style="width: 100%; height: 600px"
                ></iframe>
              </div>

              <!-- 销量排行页 -->
              <div v-if="activeTab === 'ranking'" class="ranking-content">
                <div class="ranking-columns">
                  <!-- 动态渲染每个品类 -->
                  <div
                    class="ranking-column"
                    v-for="category in productCategories"
                    :key="category.category"
                  >
                    <div class="column-header">
                      <h4>{{ category.category }}</h4>
                    </div>
                    <div class="product-list">
                      <div
                        class="product-item"
                        v-for="(product, index) in category.productSales"
                        :key="product.productId"
                      >
                        <div class="product-rank">
                          <div class="rank-number" :class="`rank-${index + 1}`">
                            {{ index + 1 }}
                          </div>
                        </div>
                        <div class="product-image">
                          <img
                            v-if="product.imageUrl"
                            :src="product.imageUrl"
                            alt="产品图片"
                            style="height: 60px !important"
                          />
                          <div v-else class="image-placeholder">
                            <i class="iconfont icon-chanpin"></i>
                          </div>
                        </div>
                        <div class="product-info">
                          <div class="product-code">{{ product.code }}</div>
                          <div class="product-name">{{ product.name }}</div>
                          <div class="product-sales">
                            <span class="sales-label">销量：</span>
                            <span class="sales-number"
                              >{{ product.sale }}{{ product.unit }}</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'dataSummary',
  props: {
    summaryData: {
      type: Object,
      default: function () {
        return {
          employeeCount: 0,
          departmentCount: 0,
          processCount: 0,
          productCount: 0,
          taskCount: 0,
          completedCount: 0,
          smartDeviceCount: 0,
          rawMaterialCount: 0,
          videoCount: 0
        }
      },
      require: true
    }
  },
  data() {
    return {
      dialogVisible: false,
      wenduRingValue: null,
      deviceStatus: '',
      totalOutput: '',
      fotalOutput: false,
      deviceList: [],
      countdown: 5,
      timer: null,
      deviceTableConfig: {
        header: ['设备种类', '已连接', '在线', '离线', '故障'],
        data: [],
        columnWidth: [120, 80, 80, 80, 80],
        rowNum: 10,
        waitTime: 7000,
        headerBGC: 'rgba(255,255,255,0.2)',
        oddRowBGC: 'rgba(255, 255, 255, 0.1)',
        evenRowBGC: 'rgba(0, 0, 0,0.1)'
      },
      sparkData: {
        temp: [],
        humidity: [],
        timestamps: []
      },
      fixedUnitData: {
        temp: [],
        humidity: [],
        timestamps: []
      },
      ring2: {
        title: {
          text: ''
        },
        series: [
          {
            type: 'gauge',
            arcLineWidth: 13,
            radius: '85%',
            data: [
              {
                name: 'itemA',
                value: 50,
                gradient: ['#4dabf7', '#69db7c', '#ffa94d', '#fe464f'],
                localGradient: true
              }
            ],
            axisLabel: {
              formatter: '{value}',
              fontSize: 20,
              style: {
                fill: '#fff',
                fontSize: 12,
                fontWeight: 'bold'
              }
            }
          }
        ]
      },
      ring: {
        series: [
          {
            type: 'gauge',
            startAngle: -Math.PI / 2,
            endAngle: Math.PI * 1.5,
            arcLineWidth: 13,
            radius: '80%',
            data: [
              {
                name: '湿度',
                value: 50,
                gradient: ['#03c2fd', '#1ed3e5', '#2fded6']
              }
            ],
            axisLabel: {
              show: false
            },
            axisTick: {
              show: false
            },
            pointer: {
              show: false
            },
            backgroundArc: {
              style: {
                stroke: '#224590'
              }
            },
            details: {
              show: true,
              formatter: '湿度{value}%',
              style: {
                fill: '#1ed3e5',
                fontSize: 20
              }
            }
          }
        ],
        color: ['#1ed3e5']
      },
      fixedUnitRing2: {
        title: {
          text: ''
        },
        series: [
          {
            type: 'gauge',
            arcLineWidth: 13,
            radius: '85%',
            data: [
              {
                name: 'itemA',
                value: 50,
                gradient: ['#4dabf7', '#69db7c', '#ffa94d', '#fe464f'],
                localGradient: true
              }
            ],
            axisLabel: {
              formatter: '{value}',
              fontSize: 20,
              style: {
                fill: '#fff',
                fontSize: 12,
                fontWeight: 'bold'
              }
            }
          }
        ]
      },
      fixedUnitRing: {
        series: [
          {
            type: 'gauge',
            startAngle: -Math.PI / 2,
            endAngle: Math.PI * 1.5,
            arcLineWidth: 13,
            radius: '80%',
            data: [
              {
                name: '湿度',
                value: 50,
                gradient: ['#03c2fd', '#1ed3e5', '#2fded6']
              }
            ],
            axisLabel: {
              show: false
            },
            axisTick: {
              show: false
            },
            pointer: {
              show: false
            },
            backgroundArc: {
              style: {
                stroke: '#224590'
              }
            },
            details: {
              show: true,
              formatter: '湿度{value}%',
              style: {
                fill: '#1ed3e5',
                fontSize: 20
              }
            }
          }
        ],
        color: ['#1ed3e5']
      },
      videoDialogVisible: false,
      showDialog: false,
      currentItem: null,
      isLoading: false,
      activeTab: 'ranking',
      // 替换为从接口获取的数据
      productCategories: []
    }
  },
  computed: {
    dataSummary: function () {
      return [
        {
          id: '1',
          title: '员工总数',
          iconfont: 'icon-yuangong',
          number: {
            number: [this.summaryData.employeeCount],
            content: '{nt}',
            textAlign: 'right',
            style: {
              fill: '#4d99fc',
              fontWeight: 'bold',
              fontSize: 35
            }
          },
          unit: '人'
        },
        {
          id: '2',
          title: '车间数量',
          iconfont: 'icon-chejianjihua',
          number: {
            number: [this.summaryData.departmentCount],
            content: '{nt}',
            textAlign: 'right',
            style: {
              fill: '#f46827',
              fontWeight: 'bold',
              fontSize: 35
            }
          },
          unit: '个'
        },
        {
          id: '3',
          title: '生产工序',
          iconfont: 'icon-gongxu',
          number: {
            number: [22],
            content: '{nt}',
            textAlign: 'right',
            style: {
              fill: '#40faee',
              fontWeight: 'bold',
              fontSize: 35
            }
          },
          unit: '道'
        },
        {
          id: '4',
          title: '产品营销',
          iconfont: 'icon-cangkukucun',
          number: {
            number: [328],
            content: '{nt}',
            textAlign: 'right',
            style: {
              fill: '#4d99fc',
              fontWeight: 'bold',
              fontSize: 35
            }
          },
          unit: '个'
        },
        {
          id: '5',
          title: '总任务量',
          iconfont: 'icon-renwu',
          number: {
            number: [this.summaryData.taskCount],
            content: '{nt}',
            textAlign: 'right',
            style: {
              fill: '#f46827',
              fontWeight: 'bold',
              fontSize: 35
            }
          },
          unit: '件'
        },
        {
          id: '6',
          title: '完成数量',
          iconfont: 'icon-wancheng',
          number: {
            number: [this.summaryData.completedCount],
            content: '{nt}',
            textAlign: 'right',
            style: {
              fill: '#40faee',
              fontWeight: 'bold',
              fontSize: 35
            }
          },
          unit: '件'
        },
        {
          id: '7',
          title: '智能设备',
          iconfont: 'icon-shebei',
          number: {
            number: [this.summaryData.smartDeviceCount],
            content: '{nt}',
            textAlign: 'right',
            style: {
              fill: '#4d99fc',
              fontWeight: 'bold',
              fontSize: 35
            }
          },
          unit: '台'
        },
        {
          id: '8',
          title: '原料品类',
          iconfont: 'icon-yuanliaoxinxi',
          number: {
            number: [this.summaryData.rawMaterialCount],
            content: '{nt}',
            textAlign: 'right',
            style: {
              fill: '#f46827',
              fontWeight: 'bold',
              fontSize: 35
            }
          },
          unit: '类'
        },
        {
          id: '9',
          title: '监控视频',
          iconfont: 'icon-jiankongshexiangtou',
          number: {
            number: [156],
            content: '{nt}',
            textAlign: 'right',
            style: {
              fill: '#40faee',
              fontWeight: 'bold',
              fontSize: 35
            }
          },
          unit: '个'
        }
      ]
    }
  },
  mounted() {
    const { createData } = this
    createData()
    setInterval(this.createData, 30000)
  },
  methods: {
    async fetchProductSalesData() {
      try {
        const response1 = await this.$axios.post(
          'https://xfhp.5any.cn/api/erpAppProduct/GetProductListOrderBySaleGroupByCategory'
        )
        console.log('response1:', response1)
        if (response1.data.code === 200) {
          this.productCategories = response1.data.result
        }
      } catch (error) {
        console.error('获取产品销量数据失败:', error)
      }
    },
    handleItemClick(item) {
      if (item.id === '4') {
        this.currentItem = item
        this.isLoading = true
        this.showDialog = true

        // 加载数据
        this.fetchProductSalesData().finally(() => {
          this.isLoading = false
        })
      }
      if (item.title === '智能设备') {
        //this.dialogVisible = true
        //this.startCountdown()
        //this.fetchDeviceData()
        //this.fetchDeviceStatistics()
      } else if (item.title === '监控视频') {
        //this.videoDialogVisible = true
      }
    },
    handleClose() {
      this.dialogVisible = false
      this.stopCountdown()
      // 停止音频播放
      this.$refs.alarmAudio.pause()
      this.$refs.alarmAudio.currentTime = 0
      this.fotalOutput = false
    },
    startCountdown() {
      this.countdown = 5
      this.timer = setInterval(() => {
        this.countdown--
        if (this.countdown <= 0) {
          this.countdown = 5
          // 同时刷新设备数据和表格数据
          Promise.all([
            this.fetchDeviceData(),
            this.fetchDeviceStatistics()
          ]).catch((error) => {
            console.error('Failed to refresh data:', error)
          })
        }
      }, 1000)
    },
    stopCountdown() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    async fetchDeviceData() {
      try {
        const response = await fetch(
          'https://htyh.5any.cn/api/ErpAppStatistics/GetDevice/ZY0001'
        )
        const result = await response.json()
        if (result.code === 200) {
          const data = result.data
          console.log('获取设备数据')
          console.log(data)

          this.deviceStatus = data.deviceStatus
          this.totalOutput =
            data.totalOutput === null ? '获取异常' : data.totalOutput
          this.fotalOutput = data.fotalOutput

          if (data.spark) {
            this.sparkData = {
              temp: data.spark.temp,
              humidity: data.spark.humidity,
              timestamps: data.spark.timestamps
            }
            const lastTempIndex = data.spark.temp.length - 1
            const lastHumidityIndex = data.spark.humidity.length - 1
            this.wenduRingValue = data.spark.temp[lastTempIndex]

            this.ring2.series[0].data[0].value = data.spark.temp[lastTempIndex]
            this.ring.series[0].data[0].value =
              data.spark.humidity[lastHumidityIndex]

            this.ring2 = JSON.parse(JSON.stringify(this.ring2))
            this.ring = JSON.parse(JSON.stringify(this.ring))
          }
          if (data.fixedUnit) {
            this.fixedUnitData = {
              temp: data.fixedUnit.temp,
              humidity: data.fixedUnit.humidity,
              timestamps: data.fixedUnit.timestamps
            }
            const lastTempIndex = data.fixedUnit.temp.length - 1
            const lastHumidityIndex = data.fixedUnit.humidity.length - 1

            this.fixedUnitRing2.series[0].data[0].value =
              data.fixedUnit.temp[lastTempIndex]
            this.fixedUnitRing.series[0].data[0].value =
              data.fixedUnit.humidity[lastHumidityIndex]
            this.fixedUnitRing2 = JSON.parse(
              JSON.stringify(this.fixedUnitRing2)
            )
            this.fixedUnitRing = JSON.parse(JSON.stringify(this.fixedUnitRing))
          }
        }
      } catch (error) {
        console.error('Failed to fetch device data:', error)
      }
    },
    async fetchDeviceStatistics() {
      try {
        const response = await fetch(
          'https://htyh.5any.cn/api/ErpAppStatistics/GetDeviceStatistics'
        )
        const result = await response.json()
        console.log('获取设备统计数据')
        console.log(result.devices)
        if (result.devices) {
          this.deviceList = result.devices.map((device) => ({
            type: device.name,
            connected: device.count,
            online: device.onlineCount,
            offline: device.offlineCount,
            error: device.errorCount
          }))
        }
      } catch (error) {
        console.error('Failed to fetch device statistics:', error)
      }
    },

    createData() {
      const { randomExtend } = this
    },
    randomExtend(minNum, maxNum) {
      if (arguments.length === 1) {
        return parseInt(Math.random() * minNum + 1, 10)
      } else {
        return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10)
      }
    },
    handleTest() {
      this.fotalOutput = true
      setTimeout(() => {
        this.fotalOutput = false
      }, 5000)
    },
    handleVideoClose() {
      this.videoDialogVisible = false
    },
    handleAudioError(e) {
      console.error('音频加载错误:', e)
    }
  },
  watch: {
    fotalOutput(newVal) {
      if (newVal === true) {
        const audio = this.$refs.alarmAudio
        const playPromise = audio.play()

        if (playPromise !== undefined) {
          playPromise
            .then(() => {
              console.log('音频开始播放')
            })
            .catch((error) => {
              console.error('音频播放失败:', error)
            })
        }
      } else {
        this.$refs.alarmAudio.pause()
        this.$refs.alarmAudio.currentTime = 0
      }
    }
  }
}
</script>

<style lang="less">
#digital-flop {
  position: relative;
  height: 15%;
  flex-shrink: 0;
  background-color: rgba(6, 30, 93, 0.5);

  .catdsBox {
    height: 100%;
    box-sizing: border-box;
    padding-top: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
  }

  .boxBorder {
    height: 100%;
    box-sizing: border-box;
    padding: 10px 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .decorationBox {
      transform: rotate(180deg);
    }
  }

  .dv-decoration-10 {
    position: absolute;
    width: 95%;
    left: 2.5%;
    height: 5px;
    bottom: 0px;
  }

  .digital-flop-item {
    width: 11%;
    height: 80%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-left: 3px solid rgb(6, 30, 93);
    border-right: 3px solid rgb(6, 30, 93);
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
      background-color: rgba(255, 255, 255, 0.1);
    }

    .titleHeader {
      display: flex;
      flex-direction: row;

      .iconfont {
        margin-right: 5px;
        font-size: 27px;
      }
    }
  }

  .digital-flop-title {
    font-size: 21px;
    font-weight: 800;
    margin-bottom: 20px;
  }

  .digital-flop {
    display: flex;
  }

  .unit {
    font-size: 20px;
    margin-left: 10px;
    display: flex;
    align-items: flex-end;
    box-sizing: border-box;
    padding-bottom: 13px;
  }

  .right {
    width: 520px;
    padding: 8px;
    border-top: none;
    border-right: none;
    border-bottom: none;
    border-left: none;
    display: flex;
    flex-direction: column;
    gap: 15px;
    background-color: rgba(6, 30, 93, 0.5);
    border-top: 2px solid rgba(1, 153, 209, 0.5);
    border-radius: 8px;
    margin: 0 auto;
  }
}

.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(6, 30, 93, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.dialog-content {
  background-color: rgba(6, 30, 93, 0.9);
  border: 2px solid #4d99fc;
  border-radius: 8px;
  width: 80%;
  max-width: 1200px;
  height: auto;
  box-shadow: 0 0 20px rgba(77, 153, 252, 0.3);
  color: #fff;
}

.dialog-header {
  padding: 20px 30px;
  border-bottom: 2px solid rgba(77, 153, 252, 0.3);
  display: flex;
  justify-content: space-between;
  align-items: center;

  h3 {
    margin: 0;
    color: #4d99fc;
    font-size: 24px;
    font-weight: bold;
  }

  .close-btn {
    font-size: 28px;
    cursor: pointer;
    color: #4d99fc;
    transition: all 0.3s;

    &:hover {
      color: #40faee;
      transform: scale(1.1);
    }
  }
}

.dialog-body {
  display: flex;
  justify-content: space-between;
  padding: 30px;
  font-size: 18px;
  color: #fff;
  height: auto;
  overflow: visible;

  > div:first-child {
    width: 40%;
    display: flex;
    flex-direction: column;
    gap: 15px;
  }

  .decorationBox {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 10px;
  }

  .title {
    font-size: 18px;
    font-weight: 700;
    margin-top: 8px;
    text-align: center;
  }

  .decoration5 {
    margin-top: -10px;
  }

  .device-table {
    width: 100%;
    border-collapse: collapse;
    background-color: rgba(6, 30, 93, 0.5);
    border-radius: 6px;
    overflow: hidden;

    th,
    td {
      padding: 8px 8px;
      text-align: center;
      border: 1px solid rgba(255, 255, 255, 0.3);
      font-size: 14px;
    }

    th {
      background-color: rgba(255, 255, 255, 0.2);
      color: #4d99fc;
      font-weight: bold;
    }

    td {
      color: #fff;
    }

    tr:hover {
      background-color: rgba(77, 153, 252, 0.1);
    }

    tbody tr:nth-child(even) {
      background-color: rgba(0, 0, 0, 0.1);
    }

    tbody tr:nth-child(odd) {
      background-color: rgba(255, 255, 255, 0.1);
    }
  }

  .catdsBox {
    width: 55%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
  }

  .right {
    width: 380px;
    padding: 8px;
    border-top: none;
    border-right: none;
    border-bottom: none;
    border-left: 1px solid #dcdfe6;
    display: flex;
    flex-direction: column;
    gap: 15px;
    background-color: rgba(6, 30, 93, 0.5);
    border-top: 2px solid rgba(1, 153, 209, 0.5);
    border-radius: 8px;

    .top {
      display: flex;
      justify-content: center;
      align-items: center;
      padding-bottom: 10px;
      flex-direction: column;
      gap: 10px;

      .status-container {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      h3 {
        margin: 0;
        text-align: center;
      }

      span {
        text-align: center;
      }
    }

    .middle {
      background-color: rgba(6, 30, 93, 0.5);
      border-top: 2px solid rgba(1, 153, 209, 0.5);
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      padding: 10px;
      border-radius: 8px;

      h4 {
        font-size: 20px;
        font-weight: 800;
        padding-left: 20px;
        margin: 10px 0;
      }

      .activeChart {
        position: relative;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-around;
        height: 130px;
        margin-top: 8px;
        background-color: rgba(6, 30, 93, 0.7);
        border-radius: 8px;
        padding: 10px;

        .wenshidu {
          display: flex;
          flex-direction: row;
          align-items: center;
          position: absolute;
          top: 80%;
          left: 12%;
          font-size: 20px;
          font-weight: 700;
          color: #fff;

          .wenduRing {
            color: #ff0000;
            animation: blinker 1s linear infinite;
          }

          .icon-wenshidu- {
            font-size: 28px;
            font-weight: normal;
          }
        }

        .icon-shidu {
          position: absolute;
          top: 60%;
          left: 71%;
          font-size: 28px;
          color: #1ed3e5;
        }
      }

      .ring-charts {
        width: 100%;
        height: 160px;
      }
    }

    .bottom {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 20px;
      padding: 15px;

      .output-box,
      .alarm-box {
        padding: 12px;
        box-sizing: border-box;
        background-color: rgba(6, 30, 93, 0.7);
        border-radius: 8px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        gap: 10px;

        .box-title {
          display: flex;
          flex-direction: row;
          align-items: center;
          gap: 5px;
          font-size: 15px;
          color: #4d99fc;
          white-space: nowrap;
        }

        .box-content {
          display: flex;
          flex-direction: row;
          align-items: center;
          font-size: 15px;
          color: #ffffff;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;

          .value {
            font-size: 15px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }

      .test-button {
        padding: 8px 15px;
        background-color: rgba(6, 30, 93, 0.7);
        border: 1px solid #4d99fc;
        border-radius: 4px;
        color: #4d99fc;
        cursor: pointer;
        font-size: 14px;
        transition: all 0.3s;

        &:hover {
          background-color: #4d99fc;
          color: #fff;
        }
      }
    }
  }
}

.dialog-footer {
  padding: 20px 30px;
  text-align: right;
  border-top: 2px solid rgba(77, 153, 252, 0.3);

  .close-button {
    padding: 10px 30px;
    background-color: transparent;
    color: #4d99fc;
    border: 2px solid #4d99fc;
    border-radius: 4px;
    cursor: pointer;
    font-size: 16px;
    transition: all 0.3s;

    &:hover {
      background-color: #4d99fc;
      color: #fff;
      box-shadow: 0 0 15px rgba(77, 153, 252, 0.5);
    }
  }
}

@keyframes blinker {
  50% {
    opacity: 0.5;
  }
}

.video-body {
  padding: 0 !important;
  height: calc(90vh - 100px) !important;
  min-height: 600px !important;
  overflow: hidden !important;

  .video-frame {
    width: 100%;
    height: 100%;
    border: none;
  }
}

// 增强的弹窗样式
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    135deg,
    rgba(6, 30, 93, 0.9),
    rgba(13, 71, 161, 0.8)
  );
  backdrop-filter: blur(10px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: modalOverlayFadeIn 0.3s ease-out;

  .modal-contentpro {
    background: linear-gradient(
      135deg,
      rgba(6, 30, 93, 0.95),
      rgba(13, 71, 161, 0.9)
    );
    border: 2px solid #4d99fc;
    border-radius: 12px;
    width: 1000px;
    height: 700px;
    padding-right: 40px;
    padding-bottom: 30px;
    box-shadow: 0 0 30px rgba(77, 153, 252, 0.4),
      0 0 60px rgba(77, 153, 252, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.1);
    color: #fff;
    position: relative;
    overflow: hidden;
    transform: scale(0.8);
    opacity: 0;
    animation: modalContentEnter 0.4s ease-out 0.1s forwards;

    .customer-tags-content {
      margin: 0;
      margin-bottom: 20px;
      width: 100%;
      height: 100%;
      overflow: auto; // 添加滚动条
    }

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        90deg,
        transparent,
        rgba(255, 255, 255, 0.1),
        transparent
      );
      animation: shimmerEffect 3s infinite;
    }
  }

  // 加载动画容器
  .loading-container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: linear-gradient(
      135deg,
      rgba(6, 30, 93, 0.98),
      rgba(13, 71, 161, 0.95)
    );
    z-index: 10;

    .loading-spinner {
      position: relative;
      width: 80px;
      height: 80px;
      margin-bottom: 20px;

      .spinner-ring {
        position: absolute;
        width: 100%;
        height: 100%;
        border: 3px solid transparent;
        border-radius: 50%;
        animation: spinnerRotate 1.5s linear infinite;

        &:nth-child(1) {
          border-top-color: #4d99fc;
          animation-delay: 0s;
        }

        &:nth-child(2) {
          border-right-color: #40faee;
          animation-delay: 0.5s;
          width: 70%;
          height: 70%;
          top: 15%;
          left: 15%;
        }

        &:nth-child(3) {
          border-bottom-color: #f46827;
          animation-delay: 1s;
          width: 40%;
          height: 40%;
          top: 30%;
          left: 30%;
        }
      }
    }

    .loading-text {
      font-size: 18px;
      color: #4d99fc;
      font-weight: 600;
      animation: loadingTextPulse 1.5s ease-in-out infinite;
    }
  }

  // 主要内容区域
  .modal-main-content {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 20px;
  }

  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    padding-bottom: 5px;
    border-bottom: 2px solid rgba(77, 153, 252, 0.3);

    .header-title {
      display: flex;
      align-items: center;

      .iconfont {
        font-size: 28px;
        color: #4d99fc;
        margin-right: 10px;
        animation: iconFloat 2s ease-in-out infinite;
      }

      h3 {
        margin: 0;
        color: #4d99fc;
        font-size: 25px;
        font-weight: bold;
        text-shadow: 0 0 50px rgba(77, 153, 252, 0.5);
      }
    }

    .close-btn {
      cursor: pointer;
      font-size: 32px;
      color: #fff;
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      transition: all 0.3s ease;

      &:hover {
        color: #f46827;
        background: rgba(244, 104, 39, 0.2);
        transform: rotate(90deg);
      }
    }
  }

  .modal-content {
    flex: 1;
    background: rgba(255, 255, 255, 0.95);
    border-radius: 8px;
    padding: 0;
    overflow: hidden;
    box-shadow: inset 0 0 20px rgba(0, 0, 0, 0.1);
  }
}

// 标签页导航
.tab-navigation {
  display: flex;
  background: linear-gradient(135deg, #4d99fc, #40faee);
  border-radius: 8px 8px 0 0;

  .tab-item {
    flex: 1;
    padding: 15px 20px;
    text-align: center;
    cursor: pointer;
    color: #fff;
    font-weight: 600;
    font-size: 16px;
    transition: all 0.3s ease;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    .iconfont {
      margin-right: 8px;
      font-size: 18px;
    }

    &:not(.active) {
      background: rgba(255, 255, 255, 0.1);

      &:hover {
        background: rgba(255, 255, 255, 0.2);
        transform: translateY(-2px);
      }
    }

    &.active {
      background: rgba(255, 255, 255, 0.9);
      color: #4d99fc;
      box-shadow: 0 -3px 10px rgba(77, 153, 252, 0.3);

      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 3px;
        background: linear-gradient(90deg, #4d99fc, #40faee);
      }
    }
  }
}

// 标签页内容
.tab-content {
  flex: 1;
  padding: 10px;
}

// 销量排行内容
.ranking-content {
  height: 580px;
  width: 100%;

  .ranking-columns {
    display: flex;
    gap: 20px;
    height: 600px;
    margin-bottom: 30px;
    padding: 5px;

    .ranking-column {
      flex: 1;
      background: rgba(6, 30, 93, 0.05);
      border-radius: 8px;
      border: 1px solid rgba(77, 153, 252, 0.2);

      .column-header {
        background: linear-gradient(135deg, #4d99fc, #40faee);
        color: #fff;
        padding: 15px;
        text-align: center;

        h4 {
          margin: 0;
          font-size: 16px;
          font-weight: 600;
        }
      }

      .product-list {
        padding: 15px;
        height: calc(100% - 100px);
        overflow-y: auto;
        overflow: auto;
        scrollbar-width: thin; // 更细的滚动条
        scrollbar-color: rgba(255, 255, 255, 0.3) transparent; // 半透明颜色

        &::-webkit-scrollbar {
          width: 6px;
          height: 6px;
          background-color: transparent;
        }

        &::-webkit-scrollbar-thumb {
          background-color: rgba(255, 255, 255, 0.2);
          border-radius: 3px;
          transition: background-color 0.3s;

          &:hover {
            background-color: rgba(255, 255, 255, 0.4);
          }
        }

        &::-webkit-scrollbar-track {
          background-color: transparent;
        }

        .product-item {
          display: flex;
          align-items: center;
          padding: 12px;
          margin-bottom: 10px;
          background: #fff;
          border-radius: 8px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
          transition: all 0.3s ease;
          animation: productItemSlideIn 0.5s ease-out;

          &:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 15px rgba(77, 153, 252, 0.2);
          }

          .product-rank {
            margin-right: 12px;

            .rank-number {
              width: 25px;
              height: 25px;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              color: #fff;
              font-weight: bold;
              font-size: 12px;

              &.rank-1 {
                background: linear-gradient(135deg, #ffd700, #ffa500);
                box-shadow: 0 0 10px rgba(255, 215, 0, 0.5);
              }

              &.rank-2 {
                background: linear-gradient(135deg, #c0c0c0, #a9a9a9);
                box-shadow: 0 0 10px rgba(192, 192, 192, 0.5);
              }

              &.rank-3 {
                background: linear-gradient(135deg, #cd7f32, #b8860b);
                box-shadow: 0 0 10px rgba(205, 127, 50, 0.5);
              }

              &:not(.rank-1):not(.rank-2):not(.rank-3) {
                background: linear-gradient(135deg, #4d99fc, #40faee);
              }
            }
          }

          .product-image {
            margin-right: 12px;

            .image-placeholder {
              width: 40px;
              height: 40px;
              background: linear-gradient(135deg, #f0f9ff, #e0f2fe);
              border-radius: 6px;
              display: flex;
              align-items: center;
              justify-content: center;
              border: 1px solid #e0f2fe;

              .iconfont {
                font-size: 20px;
                color: #4d99fc;
              }
            }
          }

          .product-info {
            flex: 1;
            margin-right: 12px;

            .product-code {
              font-size: 12px;
              color: #666;
              margin-bottom: 2px;
            }

            .product-name {
              font-size: 14px;
              color: #333;
              font-weight: 500;
            }
          }

          .product-sales {
            text-align: right;

            .sales-label {
              font-size: 12px;
              color: #666;
            }

            .sales-number {
              font-size: 16px;
              color: #4d99fc;
              font-weight: bold;
              margin-left: 4px;
            }
          }
        }
      }
    }
  }
}

// 动画定义
@keyframes modalOverlayFadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes modalContentEnter {
  to {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes shimmerEffect {
  0% {
    left: -100%;
  }

  100% {
    left: 100%;
  }
}

@keyframes spinnerRotate {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@keyframes loadingTextPulse {
  0%,
  100% {
    opacity: 0.6;
  }

  50% {
    opacity: 1;
  }
}

@keyframes iconFloat {
  0%,
  100% {
    transform: translateY(0px);
  }

  50% {
    transform: translateY(-3px);
  }
}

@keyframes productItemSlideIn {
  from {
    transform: translateX(-20px);
    opacity: 0;
  }

  to {
    transform: translateX(0);
    opacity: 1;
  }
}
</style>
